import { render, staticRenderFns } from "./PasswordPolicy.vue?vue&type=template&id=19db77f8&scoped=true"
import script from "./PasswordPolicy.vue?vue&type=script&lang=ts"
export * from "./PasswordPolicy.vue?vue&type=script&lang=ts"
import style0 from "./PasswordPolicy.vue?vue&type=style&index=0&id=19db77f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db77f8",
  null
  
)

export default component.exports